import { PushpinOutlined } from '@ant-design/icons';
import {
  IWidgetType,
  RequiredRule,
  WidgetCategory,
  WidgetMainType,
  tran,
} from '@framework/engine';
import { IMapWidget, WidgetTypeMap } from './IMapWidget';
import { MapWidgetComponent } from './MapWidgetComponent';
import { MapWidgetConfigComponent } from './MapWidgetConfigComponent';
import { MapWidgetConfigSchema } from './MapWidgetConfigSchema';
import { createMapSchema } from './createMapSchema';
import {
  getMapWidgetReferences,
  getMapWidgetSiblingReferences,
} from './references/getMapWidgetReferences';

declare module '@framework/engine/src/schema/widgets/Widget' {
  export enum WidgetType {
    Map = 'map',
  }
}

/**
 * Widget di tipo mappa per la selezione geolocalizzata.
 */
export const MapWidgetType: IWidgetType<IMapWidget> = {
  type: WidgetTypeMap,
  mainType: WidgetMainType.Input,
  category: WidgetCategory.Advanced,
  name: 'Mappa',
  icon: <PushpinOutlined />,
  hasValue: true,
  getReference: getMapWidgetReferences,
  getSiblingReferences: getMapWidgetSiblingReferences,
  formComponent: MapWidgetComponent,
  createFormSchema: createMapSchema,
  previewComponent: MapWidgetComponent,
  configComponent: MapWidgetConfigComponent,
  configOptions: {
    removeCollapsePanel: true,
  },
  configValidator: MapWidgetConfigSchema,
  translationSchema: tran.widget({
    label: tran.rte(),
    helpText: tran.rte(),
    intersection: tran.object({
      title: tran.string(),
    }),
  }),
  rules: [RequiredRule],
};
